export const html = {
    set(html, { view, elem }) {
        view.$(elem).html(`${html}`);
    },
};
//# sourceMappingURL=html.js.map